var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgXpLevel7(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 65.183,
    height: 52.682,
    viewBox: "0 0 65.183 52.682",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1420",
    "data-name": "Rectangle 1420",
    width: 65.183,
    height: 52.682,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3116",
    "data-name": "Group 3116",
    transform: "translate(-1334.816 -1908.388)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3058",
    "data-name": "Group 3058",
    transform: "translate(1334.816 1908.388)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3057",
    "data-name": "Group 3057",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33035",
    "data-name": "Path 33035",
    d: "M70.191,22.253a17.1,17.1,0,1,1-17.1-17.1,17.1,17.1,0,0,1,17.1,17.1",
    transform: "translate(-20.61 -2.952)",
    fill: "#ffb600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33117",
    "data-name": "Path 33117",
    d: "M70.191,22.253c0,9.443-7.655-1.175-17.1-1.175S36,31.7,36,22.253a17.1,17.1,0,1,1,34.2,0",
    transform: "translate(-20.61 -2.952)",
    fill: "#ffc648"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33040",
    "data-name": "Path 33040",
    d: "M50.8,38.77A18.807,18.807,0,1,1,69.612,19.962,18.828,18.828,0,0,1,50.8,38.77m0-34.2A15.388,15.388,0,1,0,66.192,19.962,15.405,15.405,0,0,0,50.8,4.575",
    transform: "translate(-18.32 -0.661)",
    fill: "#4a4e59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33042",
    "data-name": "Path 33042",
    d: "M38.1,61.125A28.532,28.532,0,0,1,12.317,20.893a.855.855,0,1,1,1.559.7,26.582,26.582,0,1,0,48.28-.364.855.855,0,1,1,1.549-.725A28.533,28.533,0,0,1,38.1,61.125",
    transform: "translate(-5.615 -11.459)",
    fill: "#4a4e59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33043",
    "data-name": "Path 33043",
    d: "M89.687,92.573s4.5,8.317-2.4,8.5c-5.783-3.773,2.4-8.5,2.4-8.5",
    transform: "translate(-48.791 -53.003)",
    fill: "#639a09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33044",
    "data-name": "Path 33044",
    d: "M99.266,110.686s-7.994,7.652-10.342-.081c2.468-7.7,10.342.081,10.342.081",
    transform: "translate(-50.914 -61.382)",
    fill: "#aed366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33045",
    "data-name": "Path 33045",
    d: "M110.71,84.068s5.993,6.386-.144,8.183c-6.07-2.013.144-8.183.144-8.183",
    transform: "translate(-61.782 -48.134)",
    fill: "#639a09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33046",
    "data-name": "Path 33046",
    d: "M123.508,95.017s-4.409,8.65-8.59,2.924c-.181-7.088,8.59-2.924,8.59-2.924",
    transform: "translate(-65.796 -53.707)",
    fill: "#aed366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33047",
    "data-name": "Path 33047",
    d: "M126.419,65.62s6.369,4.282,1.478,7.019c-5.579-.532-1.478-7.019-1.478-7.019",
    transform: "translate(-71.55 -37.571)",
    fill: "#639a09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33048",
    "data-name": "Path 33048",
    d: "M140.169,74.335s-3.046,8.412-7.522,3.652c-.973-6.461,7.522-3.652,7.522-3.652",
    transform: "translate(-75.904 -42.214)",
    fill: "#aed366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33049",
    "data-name": "Path 33049",
    d: "M129.423,45.148s7.866,1.479,4.307,6.116c-5.565,1.788-4.307-6.116-4.307-6.116",
    transform: "translate(-74.032 -25.85)",
    fill: "#639a09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33050",
    "data-name": "Path 33050",
    d: "M144.9,47.872s.327,8-4.992,5.571c-2.993-5.021,4.992-5.571,4.992-5.571",
    transform: "translate(-79.722 -27.409)",
    fill: "#aed366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33051",
    "data-name": "Path 33051",
    d: "M128.58,30.594s6.071-1.063,4.761,3.243c-3.528,2.8-4.761-3.243-4.761-3.243",
    transform: "translate(-73.619 -17.45)",
    fill: "#639a09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33052",
    "data-name": "Path 33052",
    d: "M141.986,26.692s1.979,6.759-3.077,5.819c-3.623-3.65,3.077-5.819,3.077-5.819",
    transform: "translate(-78.918 -15.283)",
    fill: "#aed366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33053",
    "data-name": "Path 33053",
    d: "M123.293,15.614s5.155-1.9,4.692,2.085c-2.648,3.014-4.692-2.085-4.692-2.085",
    transform: "translate(-70.592 -8.681)",
    fill: "#639a09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33054",
    "data-name": "Path 33054",
    d: "M135.915,10.367s2.139,5.8-2.348,5.283c-3.393-2.981,2.348-5.283,2.348-5.283",
    transform: "translate(-75.861 -5.936)",
    fill: "#aed366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33055",
    "data-name": "Path 33055",
    d: "M123.971,0s5.3,1.434,2.619,4.416c-3.9.925-2.619-4.416-2.619-4.416",
    transform: "translate(-70.864 0)",
    fill: "#639a09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33056",
    "data-name": "Path 33056",
    d: "M54.891,92.573s-4.5,8.317,2.4,8.5c5.783-3.773-2.4-8.5-2.4-8.5",
    transform: "translate(-30.603 -53.003)",
    fill: "#639a09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33057",
    "data-name": "Path 33057",
    d: "M39.377,110.686s7.994,7.652,10.342-.081c-2.469-7.7-10.342.081-10.342.081",
    transform: "translate(-22.546 -61.382)",
    fill: "#aed366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33058",
    "data-name": "Path 33058",
    d: "M34.517,84.068s-5.993,6.386.144,8.183c6.07-2.013-.144-8.183-.144-8.183",
    transform: "translate(-18.262 -48.134)",
    fill: "#639a09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33059",
    "data-name": "Path 33059",
    d: "M17.479,95.017s4.409,8.65,8.59,2.924c.18-7.088-8.59-2.924-8.59-2.924",
    transform: "translate(-10.008 -53.707)",
    fill: "#aed366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33060",
    "data-name": "Path 33060",
    d: "M19.677,65.62S13.307,69.9,18.2,72.639c5.579-.532,1.478-7.019,1.478-7.019",
    transform: "translate(-9.362 -37.571)",
    fill: "#639a09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33061",
    "data-name": "Path 33061",
    d: "M2.148,74.335s3.046,8.412,7.522,3.652c.973-6.461-7.522-3.652-7.522-3.652",
    transform: "translate(-1.23 -42.214)",
    fill: "#aed366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33062",
    "data-name": "Path 33062",
    d: "M15.9,45.148s-7.866,1.479-4.307,6.116c5.565,1.788,4.307-6.116,4.307-6.116",
    transform: "translate(-6.11 -25.85)",
    fill: "#639a09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33063",
    "data-name": "Path 33063",
    d: "M0,47.872s-.327,8,4.992,5.571C7.989,48.423,0,47.872,0,47.872",
    transform: "translate(0 -27.409)",
    fill: "#aed366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33064",
    "data-name": "Path 33064",
    d: "M17.29,30.594s-6.071-1.063-4.761,3.243c3.528,2.8,4.761-3.243,4.761-3.243",
    transform: "translate(-7.068 -17.45)",
    fill: "#639a09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33065",
    "data-name": "Path 33065",
    d: "M4.438,26.692s-1.979,6.759,3.077,5.819c3.623-3.65-3.077-5.819-3.077-5.819",
    transform: "translate(-2.322 -15.283)",
    fill: "#aed366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33066",
    "data-name": "Path 33066",
    d: "M22.879,15.614s-5.155-1.9-4.692,2.085c2.648,3.014,4.692-2.085,4.692-2.085",
    transform: "translate(-10.396 -8.681)",
    fill: "#639a09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33067",
    "data-name": "Path 33067",
    d: "M11.317,10.367s-2.14,5.8,2.348,5.283c3.393-2.981-2.348-5.283-2.348-5.283",
    transform: "translate(-6.188 -5.936)",
    fill: "#aed366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33068",
    "data-name": "Path 33068",
    d: "M23.731,0s-5.3,1.434-2.619,4.416C25.016,5.341,23.731,0,23.731,0",
    transform: "translate(-11.654 0)",
    fill: "#639a09"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3071",
    "data-name": "Group 3071",
    transform: "translate(409.191 1258.249)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32912",
    "data-name": "Path 32912",
    d: "M44.669,36.6a3.767,3.767,0,0,0-.833-2.014,3.8,3.8,0,0,0-3.79-4.07q-.1,0-.208.006a4.236,4.236,0,0,0-6.006-.073,4.259,4.259,0,0,0-1.876-.437,4.1,4.1,0,0,0-.424.022,4.25,4.25,0,0,0-3.544,2.734,4.88,4.88,0,0,0-1.744,7.925,3.438,3.438,0,0,0-.112,1.276,3.416,3.416,0,0,0,3.389,3.071,3.494,3.494,0,0,0,.353-.018c.044,0,.09-.01.135-.017a3.258,3.258,0,0,0,1.872.588,3.308,3.308,0,0,0,.339-.017,3.266,3.266,0,0,0,1.742-.718,4,4,0,0,0,.463.027,3.8,3.8,0,0,0,.381-.019,4.012,4.012,0,0,0,3.561-3.424,3.469,3.469,0,0,0,1.427-.811,3.806,3.806,0,0,0,4.877-4.03m-4.522,3.16a2.933,2.933,0,0,0,.363-1.166.33.33,0,1,0-.658-.056,2.642,2.642,0,0,1-.421,1.115c-.009.012-.05.056-.06.069a2.545,2.545,0,0,1-1.25.818.286.286,0,0,0,0-.041,3.688,3.688,0,0,0-.153-.744,3.518,3.518,0,0,0-.65-1.211,1.717,1.717,0,0,1-.294-.638,1.848,1.848,0,0,1-.038-.741,1.892,1.892,0,0,1,.551-1.05.33.33,0,0,0-.458-.476,2.552,2.552,0,0,0-.771,2.027,3.723,3.723,0,0,0-1.106-.441,3.529,3.529,0,0,0-1.268-1.819,3.587,3.587,0,0,0-.524-.328,1.612,1.612,0,0,1-.5-.29,1.2,1.2,0,0,1-.134-1.325.33.33,0,0,0-.566-.339A1.856,1.856,0,0,0,32.1,34.7a3.515,3.515,0,0,0-1.226.1.33.33,0,1,0,.171.637,2.909,2.909,0,0,1,3.427,1.7,3.754,3.754,0,0,0-.451.016,3.7,3.7,0,0,0-1.547.512.33.33,0,1,0,.34.566,3.081,3.081,0,0,1,4.648,2.333c.007.071.01.3.009.377a3.077,3.077,0,0,1-2.763,3,2.873,2.873,0,0,1-.293.012,2.7,2.7,0,0,0,.154-.256.33.33,0,0,0-.585-.306,3.175,3.175,0,0,1-.445.6,2.291,2.291,0,0,1-1.417.664,2.316,2.316,0,0,1-1.647-.47h0a2.338,2.338,0,0,1-.65-.8.33.33,0,0,0-.588.3,2.911,2.911,0,0,0,.269.425,2.489,2.489,0,0,1-1.787-4.188.33.33,0,0,0-.48-.453,3.054,3.054,0,0,0-.388.513,3.961,3.961,0,0,1,2.519-6.6.33.33,0,1,0-.066-.657c-.1.01-.2.027-.3.045a3.3,3.3,0,0,1,4.471-1.457,4.044,4.044,0,0,0-.232.4.33.33,0,1,0,.591.294,3.353,3.353,0,0,1,.423-.642,3.3,3.3,0,0,1,5.088,0c.015.018.033.033.048.048a3.324,3.324,0,0,1,.544,1,.33.33,0,1,0,.625-.212,3.983,3.983,0,0,0-.343-.746A2.871,2.871,0,0,1,42.9,34.033a2.908,2.908,0,0,1-.019.7.329.329,0,0,0,.087.274,2.846,2.846,0,0,1,.773,1.683,2.868,2.868,0,0,1-3.6,3.067",
    transform: "translate(923.741 632.026)",
    fill: "#4a4e59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32913",
    "data-name": "Path 32913",
    d: "M55.725,38.3a.33.33,0,0,0-.043-.465,1.928,1.928,0,0,0-2.118-.133,3.03,3.03,0,0,0-1.894-1.363.653.653,0,0,1-.5-.3.791.791,0,0,1,.088-.967.33.33,0,1,0-.482-.451,1.444,1.444,0,0,0-.221,1.67,3.04,3.04,0,0,0-1.943,1.1.33.33,0,1,0,.513.416A2.385,2.385,0,0,1,53.256,40a.33.33,0,1,0,.631.194,3.035,3.035,0,0,0-.04-1.9,1.262,1.262,0,0,1,1.413.044.33.33,0,0,0,.465-.043",
    transform: "translate(909.459 628.839)",
    fill: "#4a4e59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32914",
    "data-name": "Path 32914",
    d: "M35.689,49.754A1.293,1.293,0,0,1,34.3,48.416a.33.33,0,0,0-.66-.024,1.957,1.957,0,0,0,1.949,2.028l.05,0a3.217,3.217,0,0,0,.493,1.626,1.749,1.749,0,0,0-.41.071,1.6,1.6,0,0,0-1.056,1,.33.33,0,0,0,.205.419.335.335,0,0,0,.107.018.33.33,0,0,0,.312-.223.931.931,0,0,1,.623-.584,1.156,1.156,0,0,1,.937.134c.058.036.126.051.186.095a2.418,2.418,0,0,0,.233.143,3.192,3.192,0,0,0,3.417-.2.33.33,0,0,0-.387-.536,2.527,2.527,0,0,1-3.81-3.025.33.33,0,0,0-.609-.255,3.162,3.162,0,0,0-.19.648",
    transform: "translate(918.455 620.65)",
    fill: "#4a4e59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32915",
    "data-name": "Path 32915",
    d: "M31.622,43.475a.331.331,0,0,0-.371-.283,1.73,1.73,0,0,0-1.135.683,1.836,1.836,0,0,0-.362,1.291.33.33,0,0,0,.328.294l.036,0a.33.33,0,0,0,.292-.364,1.17,1.17,0,0,1,.234-.822,1.065,1.065,0,0,1,.7-.426.33.33,0,0,0,.283-.371",
    transform: "translate(920.806 623.6)",
    fill: "#4a4e59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32916",
    "data-name": "Path 32916",
    d: "M67.241,46.947a.33.33,0,0,0-.242.4.9.9,0,0,1-.732,1.1.33.33,0,1,0,.1.652,1.56,1.56,0,0,0,1.27-1.911.331.331,0,0,0-.4-.242",
    transform: "translate(898.919 621.337)",
    fill: "#4a4e59"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXpLevel7);
export default __webpack_public_path__ + "static/media/xpLevel7.170b76368f246e35574f2a559bb7e111.svg";
export { ForwardRef as ReactComponent };